
    <div align="center" class="col_yellow">
      <button aria-label="Close" class="close opacity_1_imp" type="button">
        <span aria-hidden="true" class="col_yellow"
              (click)="snackBarRef.dismiss()">×</span>
      </button>
    </div>
    <div class="row image_viewer_row">
      <div class="col-xs-12 col-sm-12 col-lg-12">
        <img [src]="imageSrc" class="width-100-per height-100-per">
      </div>
    </div>
  